if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setUpCarouselNav();
        this.showActiveMedia();
      }

      setUpCarouselNav() {
        if (this.carouselNavReady) return;
        this.carouselNavReady = true;

        const container = this.querySelector('[role="document"]');
        const prev = this.querySelector('.product-media-modal__nav--prev');
        const next = this.querySelector('.product-media-modal__nav--next');
        if (!container || !prev || !next) return;

        prev.addEventListener('click', () => {
          container.scrollBy({ left: -container.clientWidth, behavior: 'smooth' });
        });
        next.addEventListener('click', () => {
          container.scrollBy({ left: container.clientWidth, behavior: 'smooth' });
        });

        this.updateCarouselNav = () => {
          const isMobileCarousel = window.matchMedia('(max-width: 749px)').matches;
          const maxScroll = container.scrollWidth - container.clientWidth;
          const single = maxScroll <= 5;
          prev.toggleAttribute('hidden', !isMobileCarousel || single || container.scrollLeft <= 5);
          next.toggleAttribute('hidden', !isMobileCarousel || single || container.scrollLeft >= maxScroll - 5);
        };

        container.addEventListener('scroll', () => this.updateCarouselNav(), { passive: true });
        window.addEventListener('resize', () => this.updateCarouselNav());
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        const isMobileCarousel = window.matchMedia('(max-width: 749px)').matches;

        if (isMobileCarousel) {
          // Mobile: the modal is a horizontal swipe carousel — jump to the tapped slide.
          container.scrollLeft = activeMedia.offsetLeft;
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (this.updateCarouselNav) this.updateCarouselNav();

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
